import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { homeRouteFor } from "../auth/home-route";

/**
 * Painel do candidato do Trabalhe Conosco (spec 028). Quem é da escola volta
 * para o próprio painel.
 */
export const candidateGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthService);

  if (!auth.isLoggedIn()) return router.createUrlTree(["/login"]);
  if (auth.isCandidate()) return true;
  return router.createUrlTree(homeRouteFor(auth));
};

/**
 * O candidato não é da escola: qualquer tela da escola o devolve ao painel
 * dele. Guard é UX — quem barra de verdade é o backend (spec 028).
 */
export function candidateRedirect(): ReturnType<CanActivateFn> | null {
  const auth = inject(AuthService);
  return auth.isCandidate()
    ? inject(Router).createUrlTree(["/candidato"])
    : null;
}
